import { useSelector } from "react-redux";
import styled from "styled-components";
import { MdMoreHoriz } from "react-icons/md";
import { useDispatch } from "react-redux";
import {setSelectedKayitliAdres } from "../../features/kayit/kayitSlice";
import { showModal } from "../../features/modal/modalSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100% !important;
      padding: 20px 10px !important;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      
      /* border: 1px solid ; */
      /* border-color: ${({ theme }) => theme.mainBorderColor}; */
      background-color: var(--color-light);
      .more{
        position: absolute;
        right: 10px;
        top: 5px;
        font-size: 25px;
        cursor: pointer;
      }
      .row {
        width: 95%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        padding-bottom: 0px !important;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          color: ${({ theme }) => theme.mainTextColor};
        }
      }
    }
  }
`;

const KayitliAdreslerContainer = ({ data, selectFromId, selectedItem, setSelectedItem }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch()

  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">

          <div className="row">
            <div className="col">{data?.addressName}</div>
            <div className="col">{data?.addressCity}</div>
            <div className="col">{data?.addressTown}</div>
            <div className="col">{data?.address}</div>
          </div>

          <div className="more" onClick={() => {dispatch(showModal("adresKayitItemOptions")); dispatch(setSelectedKayitliAdres(data))}}>
              <MdMoreHoriz />
          </div>
          
        </div>
      </div>
    </Container>
  );
};

export default KayitliAdreslerContainer;
